import axios from "axios";

const ARK_API_URL = process.env.ARK_API_URL;

export const getPosts = async (currentPage, pageSize) => {
  try {
    const { data } = await axios.get(
      `${ARK_API_URL}/posts/all?currentPage=${currentPage}&pageSize=${pageSize}`
    );
    const posts = data.data.posts;
    return posts;
  } catch (error) {
    console.error("Error fetching posts:", error);
  }
};

export const getPostById = async (postId) => {
  try {
    const { data } = await axios.get(`${ARK_API_URL}/posts/all/${postId}`);
    const post = data.data;
    return post;
  } catch (error) {
    console.error("Error fetching post:", error);
  }
};
